const vapeportwholesale = {
    id: 'vapeportwholesale',
    publicSiteName: 'Vape Port Wholesale',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#b30202',
            secondary: '#000000',
            color1: '#dc0e0e',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapeportwholesale/favicon.ico',
        logo: '/vapeportwholesale/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
    pricing: {
        showVatBreakdown: true,
        vatDisplayFormat: 'both',
    },
}

export default vapeportwholesale